import {useI18n} from '@logistics-frontend/core/i18n'
import React, {useCallback, useMemo} from 'react'

import {DetailsProps} from '../../types'
import {
  formatWhiteListItemsProp,
  getPaidWaiting,
  getTaximiterDistanceIntervals,
  getTaximiterTimeIntervals,
} from '../../utils'
import {DetailsList} from '../details-list'

const SUBURB_ZONE = 'suburb'

type Props = DetailsProps & {
  taximeterZone: string
  taximeterZoneTranslate: string
}

const RideDetails: React.FC<Props> = ({taximeterZone, taximeterZoneTranslate, zone, tariff, currencySign}) => {
  const t = useI18n()
  const rideDetails = useMemo(
    () =>
      formatWhiteListItemsProp([
        ...getTaximiterDistanceIntervals(tariff, taximeterZone, `${currencySign}/${t('tariffs.units.distance')}`, t),
        ...getTaximiterTimeIntervals(tariff, taximeterZone, `${currencySign}/${t('tariffs.units.time')}`, t),
        getPaidWaiting(tariff, currencySign, t),
      ]),
    [tariff, taximeterZone, currencySign, t],
  )

  const getTaximitersZoneTitle = useCallback(
    ({taximeterZone, taximeterZoneTranslate}) =>
      taximeterZone === zone // если это та же зона
        ? t('tariffs.block_title.city_ride')
        : taximeterZone === SUBURB_ZONE // если это олбласть
        ? t('tariffs.block_title.suburb_ride')
        : t('tariffs.block_title.zone_ride', {
            placeholder: {zone: taximeterZoneTranslate},
          }),
    [t, zone],
  )

  return <DetailsList items={rideDetails} title={getTaximitersZoneTitle({taximeterZone, taximeterZoneTranslate})} />
}

export default RideDetails
